import { constants } from '@config';
import Store from '@store';

export function extractStylesFromMetadata () {
  const tableOfContentsData = Store.getState()?.metadata?.table_of_contents;
  const {
    level_styles: levelStyles
  } = tableOfContentsData;

  if (!levelStyles?.length) return [];

  const result = [];
  for (const levelStyle of levelStyles) {
    const style = extractStylesForEachLevel(levelStyle);
    result.push(style);
  }

  return result;
}

function extractStylesForEachLevel (levelStyle) {
  const paragraphStylesData = Store.getState()?.metadata?.paragraph_styles;
  const tableOfContentsData = Store.getState()?.metadata?.table_of_contents;
  const supportedStyles = constants.tableOfContents.supportedStyles;
  const result = {};

  for (const style of supportedStyles) {
    const styleName = style.replace('list_', '');
    const type = style.startsWith('list_') ? 'list_style' : 'content_style';
    const typeStyle = Array.isArray(levelStyle?.[type])
      ? {}
      : levelStyle?.[type];

    result[style] =
      typeStyle?.[styleName] ||
      levelStyle?.[style] ||
      paragraphStylesData?.styles?.[levelStyle?.paragraph_style]?.[styleName];

    result[style] = typeof result[style] === 'boolean'
      ? result[style]
      : result[style] || tableOfContentsData?.[styleName] || null;
  }

  return result;
}
